export const RECOIL_KEY = {
  PHOTO_BLOBS: 'photoBlobs',
  DISPLAYED_PHOTO : 'displayedPhoto',
  OLDEST_TIME: 'oldestTime',
  DISPLAYED_ARTICLE : 'displayedArticle'
} as const